// test1570
(1570 && 0);
